"use client";

import {useEffect, useState} from "react";
import {useRouter} from "next/navigation";
import Link from "next/link";
import {cn} from "@/common/lib/utils";
import {buttonVariants} from "@/common/components/ui/button";
import {Icons} from "@/common/components/icons";

export function BackHomeButton() {
    const router = useRouter();
    const [hasHistory, setHasHistory] = useState<boolean | null>(null);

    useEffect(() => {
        setHasHistory(window.history.length > 1);
    }, []);

    if (hasHistory === null) return null;

    if (hasHistory) {
        return (
            <button
                onClick={() => router.back()}
                className={cn(
                    buttonVariants({variant: "ghost", size: "sm"}),
                    "absolute right-4 top-4 z-20"
                )}
            >
                <Icons.chevronLeft className="mr-1 size-4"/>
                Back
            </button>
        );
    }

    return (
        <Link
            href="/"
            className={cn(
                buttonVariants({variant: "ghost", size: "sm"}),
                "absolute right-4 top-4 z-20"
            )}
        >
            <Icons.home className="mr-1 size-4"/>
            Home
        </Link>
    );
}
